import { Box } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Box)`
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const Content = styled(Box)`
  height: 100%;
  margin-top: -35px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 38px;
`;

export const ProfileStatsWrapper = styled(Box)`
  display: flex;
  gap: 24px;
`;
export const StatsWrapper = styled(Box)`
  display: flex;
  gap: 12px;
`;
